exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Editor{margin-top:15px;margin-bottom:15px}.Editor .ql-editor{min-height:150px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/pages/Facility/Editor/style.scss
// module id = 6441
// module chunks = 0